<template>
  <v-card class="cash-balances-card">
    <v-card-title
      class="text-center justify-center py-6 px-sm-16 secondary flex-column flex-sm-row justify-sm-space-between"
      style="border-bottom:1px solid white !important;"
    >
      <div class="font-weight-normal white--text pb-5 pb-sm-0" style="font-size:2rem !important">
        Account Groups
      </div>
      <custom-date-picker
        defaultStartDate="04/10/2017"
        @startDateChanged="handleStartDateChanged($event)"
      ></custom-date-picker>
    </v-card-title>
    <v-tabs
      v-model="tab"
      background-color="secondary"
      text-color="white"
      class="text--white white--text"
      show-arrows
      center-active
      fixed-tabs
    >
      <v-tab v-for="(acctGroup, idx) in cashAccountGroups" :key="idx">
        <!-- {{ acctGroup.name.substring(0, 10) }} -->
        {{ `(${acctGroup.groupTag}) ${acctGroup.displayGroup}` }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item v-for="(acctGroup, idx) in cashAccountGroups" :key="idx">
        <!-- <v-card flat>
          <v-card-text>{{ item.content }}</v-card-text>
        </v-card>-->

        <cash-account-component
          :cashAccountGroupGUID="acctGroup.generatedGUID"
        ></cash-account-component>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import CashAccountComponent from "@/components/CashAccountComponent";

export default {
  name: "cash-balances",
  mounted() {
    this.acquireAccountGroups();
  },
  data() {
    return {
      tab: null,
    };
  },
  methods: {
    handleStartDateChanged(evtActuallyDate) {
      this.$store.commit("cashmanagement/SET_LEDGER_DATE_FROM_DATE", evtActuallyDate);
      this.acquireAccountGroups();
    },
    // handleEndDateChanged(evtActuallyDate) {
    //   this.$store.commit("cashmanagement/SET_LEDGER_DATE_FROM_DATE", evtActuallyDate);
    // },
    acquireAccountGroups() {
      this.$root.setBusy("acquireAccountGroups", "Loading account groups . . .");
      return this.$store
        .dispatch("cashmanagement/acquireAccountGroups")
        .then((resp2) => {
          // console.log(this.cashAccountGroups);
          if (this.cashAccountGroups.length > 0) {
            this.tab = 0;
          }
        })
        .finally(() => {
          this.$root.removeBusy("acquireAccountGroups");
        });
    },
  },
  computed: {
    cashAccountGroups() {
      let acctGroups = this.$store.getters["cashmanagement/cashAccountGroups"];

      if (Array.isArray(acctGroups)) {
        acctGroups.sort((a, b) => {
          if (a.groupTag > b.groupTag) return 1;
          if (a.groupTag < b.groupTag) return -1;
          return 0;
        });

        return acctGroups;
      }
    },
  },
  components: {
    CashAccountComponent,
  },
};
</script>

<style lang="scss">
.cash-balances-card {
  .v-slide-group__prev *,
  .v-slide-group__next * {
    color: white !important;
  }

  [aria-selected="false"] {
    color: #aaa !important;
  }
}
</style>
